import React, { useState } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { SearchIcon, HelpCircleIcon, BookIcon, ShoppingCartIcon, PackageIcon, CreditCardIcon, UsersIcon, ArrowRightIcon } from 'lucide-react';
export const HelpCenterPage = () => {
  const [scrolled, setScrolled] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  // FAQ categories
  const categories = [{
    title: 'Getting Started',
    icon: <HelpCircleIcon className="h-6 w-6 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-5721" />,
    questions: ['How do I create an account?', 'What can I do with my account?', 'How do I reset my password?', 'Can I have both a buyer and seller account?']
  }, {
    title: 'Buying Products',
    icon: <ShoppingCartIcon className="h-6 w-6 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-5722" />,
    questions: ['How do I purchase a product?', 'What payment methods are accepted?', 'How do I download my purchased items?', 'What is your refund policy?']
  }, {
    title: 'Selling Products',
    icon: <PackageIcon className="h-6 w-6 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-5723" />,
    questions: ['How do I become a seller?', 'What products can I sell?', 'How do I submit a product for review?', 'How much commission does HubStore take?']
  }, {
    title: 'Payments & Billing',
    icon: <CreditCardIcon className="h-6 w-6 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-5724" />,
    questions: ['When do I get paid for my sales?', 'How do I update my payment information?', 'Why was my payment declined?', 'How do taxes work for international sellers?']
  }, {
    title: 'Account Management',
    icon: <UsersIcon className="h-6 w-6 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-5725" />,
    questions: ['How do I change my account details?', 'Can I change my username?', 'How do I delete my account?', 'How do I set up two-factor authentication?']
  }, {
    title: 'Documentation',
    icon: <BookIcon className="h-6 w-6 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-5726" />,
    questions: ['Where can I find API documentation?', 'Do you have integration guides?', 'How do I use the seller dashboard?', 'Are there tutorials for using product templates?']
  }];
  // Popular articles
  const popularArticles = ['How to create your first digital product', 'Understanding licensing options for your products', 'Tips for creating product previews that sell', 'How to price your digital products effectively', 'Setting up your seller profile for success'];
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-5727">
      <Navbar scrolled={scrolled} data-id="element-5728" />
      <main className="pt-24 pb-20" data-id="element-5729">
        <div className="container mx-auto px-4 md:px-6" data-id="element-5730">
          <div className="max-w-6xl mx-auto" data-id="element-5731">
            {/* Header */}
            <div className="text-center mb-12" data-id="element-5732">
              <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800 dark:text-[#F8FAF9]" data-id="element-5733">
                Help Center
              </h1>
              <p className="text-xl text-gray-600 dark:text-[#B0C1BD] max-w-3xl mx-auto mb-8" data-id="element-5734">
                Find answers to common questions and learn how to get the most
                out of HubStore
              </p>
              {/* Search */}
              <div className="max-w-2xl mx-auto" data-id="element-5735">
                <div className="relative" data-id="element-5736">
                  <input type="text" placeholder="Search for help articles..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full px-5 py-4 pr-12 rounded-xl border border-gray-200 dark:border-[#1A3330] bg-white dark:bg-[#162825] text-gray-800 dark:text-[#F8FAF9] focus:outline-none focus:ring-2 focus:ring-[#2DB489] dark:focus:ring-[#4ED1A0]" data-id="element-5737" />
                  <SearchIcon className="absolute right-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400 dark:text-[#7A8F8A]" data-id="element-5738" />
                </div>
              </div>
            </div>
            {/* Categories */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-5739">
              {categories.map((category, index) => <div key={index} className="bg-white dark:bg-[#162825] rounded-xl p-6 shadow-sm hover:shadow-md transition-all" data-id="element-5740">
                  <div className="flex items-center mb-4" data-id="element-5741">
                    <div className="w-10 h-10 rounded-full bg-[#2DB489]/10 flex items-center justify-center mr-3" data-id="element-5742">
                      {category.icon}
                    </div>
                    <h2 className="text-xl font-semibold text-gray-800 dark:text-[#F8FAF9]" data-id="element-5743">
                      {category.title}
                    </h2>
                  </div>
                  <ul className="space-y-2 mb-4" data-id="element-5744">
                    {category.questions.map((question, qIndex) => <li key={qIndex} data-id="element-5745">
                        <button className="text-left w-full text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-5746">
                          {question}
                        </button>
                      </li>)}
                  </ul>
                  <button className="inline-flex items-center text-[#2DB489] dark:text-[#4ED1A0] font-medium hover:underline" data-id="element-5747">
                    View all
                    <ArrowRightIcon className="h-4 w-4 ml-1" data-id="element-5748" />
                  </button>
                </div>)}
            </div>
            {/* Popular Articles */}
            <div className="bg-white dark:bg-[#162825] rounded-xl p-8 shadow-sm mb-16" data-id="element-5749">
              <h2 className="text-2xl font-bold mb-6 text-gray-800 dark:text-[#F8FAF9]" data-id="element-5750">
                Popular Articles
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5751">
                {popularArticles.map((article, index) => <button key={index} className="flex items-center p-4 border border-gray-200 dark:border-[#1A3330] rounded-lg hover:bg-gray-50 dark:hover:bg-[#1A3330] transition-colors text-left" data-id="element-5752">
                    <BookIcon className="h-5 w-5 text-[#2DB489] dark:text-[#4ED1A0] mr-3 flex-shrink-0" data-id="element-5753" />
                    <span className="text-gray-700 dark:text-[#B0C1BD]" data-id="element-5754">
                      {article}
                    </span>
                  </button>)}
              </div>
            </div>
            {/* Contact Support */}
            <div className="bg-gradient-to-r from-[#0A3C52] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-xl p-8 text-white" data-id="element-5755">
              <div className="flex flex-col md:flex-row items-center justify-between" data-id="element-5756">
                <div className="mb-6 md:mb-0" data-id="element-5757">
                  <h2 className="text-2xl font-bold mb-2" data-id="element-5758">Still Need Help?</h2>
                  <p className="opacity-90 max-w-xl" data-id="element-5759">
                    Our support team is ready to assist you with any questions
                    or issues you might have.
                  </p>
                </div>
                <div className="flex flex-col sm:flex-row gap-4" data-id="element-5760">
                  <button className="bg-white text-[#0A3C52] px-6 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors" data-id="element-5761">
                    Contact Support
                  </button>
                  <button className="bg-transparent border border-white text-white px-6 py-3 rounded-lg font-medium hover:bg-white/10 transition-colors" data-id="element-5762">
                    Submit a Ticket
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-5763" />
    </div>;
};